var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"text-body-1 d-flex justify-center",attrs:{"dense":"","type":"error"}},[_vm._v(" Le service est momentanément indisponible. Veuillez rééssayer ultérieurement. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }